/*
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-10-17 21:20:09
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-10-19 15:04:53
 * @FilePath: \web\src\api\staff.js
 * @Description: 友情链接api接口请求工具方法
 */
import request from '../utils/request'

// 添加
export const addStaff = data => {
  return request({
    method: 'POST',
    url: '/staff/add',
    data: data
  })
}

// 更新
export const updateStaff = data => {
  return request({
    method: 'PUT',
    url: '/staff/update',
    data: data
  })
}

// 删除
export const deleteStaffs = data => {
  const params = new URLSearchParams()
  params.append("ids", data);
  return request({
    method: 'POST',
    url: '/staff/deleteBatch',
    //params: qs.stringify({ ids: data }, { arrayFormat: 'indices' })
    data: { ids: data }
  })
}

// 查询列表
export const getStaffList = data => {
  return request({
    method: 'GET',
    url: '/staff/pageQuery',
    params: data
  })
}
